import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" {...props}><path d="M416 277.33H277.33V416h-42.66V277.33H96v-42.66h138.67V96h42.66v138.67H416v42.66z" /></svg>;